import {inject} from "@angular/core";
import {ActivatedRouteSnapshot, ResolveFn, RouterStateSnapshot} from "@angular/router";
import {Observable} from "rxjs";
import {RaceCommercialService} from "@services";
import {RaceAdditionalPricingItem} from "@model";

export const RaceAdditionalPricingItemsPublicResolver: ResolveFn<Observable<RaceAdditionalPricingItem[]> | RaceAdditionalPricingItem[]> =
  (route: ActivatedRouteSnapshot,
   state: RouterStateSnapshot,
   raceCommercialService: RaceCommercialService = inject(RaceCommercialService)): Observable<RaceAdditionalPricingItem[]> | RaceAdditionalPricingItem[] => {
    if (+route.queryParams['raceId']) {
      return raceCommercialService.findPublicRaceAdditionalPricingItems(+route.queryParams['raceId']);
    } else {
      return [];
    }
  }
